<ion-backdrop *ngIf="showBackdrop" [visible]="true"></ion-backdrop>
<ion-toolbar mode="md">
  <ion-buttons slot="start" class="back-button">
    <button nbButton ghost (click)="dismiss()" size="large" class="px-2"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
  </ion-buttons>
  <ion-title>Build circles from phone</ion-title>

</ion-toolbar>
<ion-content>
<ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
  <ion-refresher-content></ion-refresher-content>
</ion-refresher>

<nb-stepper orientation="horizontal" [selectedIndex]="selectedStep" (stepChange)="onStepChange($event)">
  <nb-step label="Inner Circle">
    <div class="ion-text-center" *ngIf="!contactsPermissionGranted">
      <button (click)="getContacts(true)" nbButton shape="round" size="small">Select contacts from phone</button>
    </div>
    <ion-list>
      <ng-container *ngFor="let contact of unaddedContacts['inner']">
        <ion-item [disabled]="contact.circle !== 'inner' && contact.circle !== null && contact.circle !== undefined" class="" lines="full">
          <ion-label>{{contact.name.display}}</ion-label>
          <ion-checkbox (ionChange)="onSelectionChange(contact, 'inner', $event)" slot="end"></ion-checkbox>
        </ion-item>
      </ng-container>
    </ion-list>
  </nb-step>
  <nb-step label="Close Friends">
    <div class="ion-text-center" *ngIf="!contactsPermissionGranted">
      <button (click)="getContacts()" nbButton shape="round" size="small">Select contacts from phone</button>
    </div>
    <ion-list>
      <ng-container *ngFor="let contact of unaddedContacts['close']">
        <ion-item [disabled]="contact.circle !== 'close' && contact.circle !== null && contact.circle !== undefined" class="" lines="full">
          <ion-label>{{contact.name.display}}</ion-label>
          <ion-checkbox (ionChange)="onSelectionChange(contact, 'close', $event)" slot="end"></ion-checkbox>
        </ion-item>
      </ng-container>
    </ion-list>
  </nb-step>
  <nb-step label="Casual Friends">
    <div class="ion-text-center" *ngIf="!contactsPermissionGranted">
      <button (click)="getContacts()" nbButton shape="round" size="small">Select contacts from phone</button>
    </div>
    <ion-list>
      <ng-container *ngFor="let contact of unaddedContacts['casual']">
        <ion-item [disabled]="contact.circle !== 'casual' && contact.circle !== null && contact.circle !== undefined" class="" lines="full">
          <ion-label>{{contact.name.display}}</ion-label>
          <ion-checkbox (ionChange)="onSelectionChange(contact, 'casual', $event)" slot="end"></ion-checkbox>
        </ion-item>
      </ng-container>
    </ion-list>
  </nb-step>
</nb-stepper>

<!-- TODO: Handle no selected contacts -->

<ion-modal trigger="open-date-modal" [breakpoints]="[0,0.3]" [initialBreakpoint]="0.3" [backdropBreakpoint]="0.2" (willDismiss)="onDismissDateModal($event)" [keepContentsMounted]="true">
  <ng-template>
    <ion-datetime id="datetime" presentation="date" [preferWheel]="true" [showDefaultButtons]="true" size="cover" [value]="person?.dob" (ionChange)="changeDOB($event)"></ion-datetime>
  </ng-template>
</ion-modal>

<ion-fab slot="fixed" vertical="bottom" horizontal="center">
  <button class="full-button page-button" (click)="nextStep()" nbButton size="giant" shape="round" outline status="primary">
    {{selectedStep === 2 ? "Add Selection To Circles" : "Next"}}
    <nb-icon *ngIf="selectedStep === 2" icon="plus-outline"></nb-icon>
    <nb-icon *ngIf="selectedStep < 2" icon="arrow-forward-outline"></nb-icon>
  </button>
</ion-fab>
</ion-content>